import { render, staticRenderFns } from "./PracticasEnEmpresas.vue?vue&type=template&id=4e54ed95&scoped=true&"
import script from "./PracticasEnEmpresas.vue?vue&type=script&lang=js&"
export * from "./PracticasEnEmpresas.vue?vue&type=script&lang=js&"
import style0 from "./PracticasEnEmpresas.vue?vue&type=style&index=0&id=4e54ed95&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e54ed95",
  null
  
)

export default component.exports